// extracted by mini-css-extract-plugin
module.exports = {"errorBox":"styles_errorBox__B5IaF","container":"styles_container__25EJ1","input":"styles_input__8zukT","btnContinue":"styles_btnContinue__llV1J"};